import type { ReactNode } from 'react';
import * as Sentry from '@sentry/react';

/**
 * Sentry provider that wraps the app with profiler for component render timing.
 * Browser tracing is now handled automatically by tanstackRouterBrowserTracingIntegration.
 */
export const SentryProvider = Sentry.withProfiler(({ children }: { children: ReactNode }) => (
  <>{children}</>
));
